import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { useBoolean } from "@miplatform/hooks";
import { useOrdersViewModel } from "./useOrdersViewModel";

const OrdersContext = createContext();

export const OrdersProvider = ({ children }) => {
  const [selectedOrder, setSelectedOrder] = useState({});
  const [isOrderActivityDrawerOpen, openDrawer, closeDrawer] = useBoolean();
  const [emailDrawer, setEmailDrawer] = useState(null);
  const [emailPreview, setEmailPreview] = useState(null);
  const { getOrderActivity } = useOrdersViewModel();

  const handleEmailDrawerOpen = useCallback(
    ({ order, templateType }) => {
      closeDrawer();
      setEmailDrawer({
        order,
        templateType,
        isOpen: true,
      });
    },
    [closeDrawer]
  );

  const handleEmailDrawerClose = useCallback(() => {
    setEmailDrawer((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }, []);

  const handleEmailPreviewModalOpen = useCallback((emailDetails) => {
    setEmailPreview(emailDetails);
  }, []);

  const handleEmailPreviewModalClose = useCallback(() => {
    setEmailPreview(null);
  }, []);

  const value = useMemo(
    () => ({
      isOrderActivityDrawerOpen,
      emailDrawer,
      emailPreview,
      selectedOrder,
      openDrawer,
      closeDrawer,
      handleEmailDrawerOpen,
      handleEmailDrawerClose,
      handleEmailPreviewModalOpen,
      handleEmailPreviewModalClose,
      setSelectedOrder,
      getOrderActivity,
    }),
    [isOrderActivityDrawerOpen, emailPreview, emailDrawer, selectedOrder]
  );

  return (
    <OrdersContext.Provider value={value}>{children}</OrdersContext.Provider>
  );
};

export const useOrdersContext = () => {
  const context = useContext(OrdersContext);
  if (!context) {
    throw new Error("useOrdersContext must be used within a OrdersProvider");
  }
  return context;
};
